import React, { useEffect, useState } from 'react'
import {Search,Message,DarkMode,LightMode,Notifications,Help,Menu,} from "@mui/icons-material";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { setLogout, setMode } from '../redux/appSlice';
const Navbar = () => {
    const [smallScreen,setSmallScreen]=useState(false)
    const [value,setValue]=useState(100)
    const {firstName}=useSelector((state)=>state.app.user)
    const [selectState,setSelectState]=useState(firstName)
    const {mode}=useSelector((state)=>state.app)
    const dispatch=useDispatch()
    const navigate=useNavigate()

    // this will be executed whenever page reload and on window event
    useEffect(()=>{
        if(window.innerWidth<=640){
                setSmallScreen(true)
                setValue(100)
            }
            else{
                setSmallScreen(false)
            }
        window.addEventListener("resize",()=>{
            if(window.innerWidth<=640){
                setSmallScreen(true)
                setValue(100)
            }
            else{
                setSmallScreen(false)
            }
        })
    },[])

    //handle menu toggle
    const handleMenuToggle=(e)=>{
        setValue((prev)=>prev===100?0:100)

    }
    
    //this will handle form data when form data changes it will run and update form data state
    const handleChange=(e)=>{
        const {value}=e.target
        setSelectState(value)
        if(value==="Logout"){
            dispatch(setLogout())
        navigate("/")
        }
    }

  return (
    <>
    <div className='w-full bg-white dark:bg-gray-900 px-10 py-4'>
        <div className='flex justify-between gap-2'>
            <div className="flex items-center gap-4">
                {/* SocioConnect */}
                <Link to="/home">
                    <h1 className='text-rose-700 font-bold text-xl'>SocioConnect</h1>
                </Link>
                {/* if not smallScreen then below Jsx will render */}
                {!smallScreen &&(
                    <div className='sm:flex sm:flex-row sm:px-4 sm:py-1 sm:rounded-md sm:bg-gray-200 dark:bg-[#3D3B3B] sm:w-40 hidden'>
                     <input className=' w-full text-sm bg-gray-200 dark:bg-[#3D3B3B]' type="text" placeholder='Search...' />
                     <Search className="text-gray-400 search-style bg-gray-200 dark:bg-[#3D3B3B]"/>
                    </div>
                )}
            </div>
            {/* if not small screen show icon otherwise show only menubar */}
            {!smallScreen?(
                <div className='sm:flex sm:gap-6 sm:items-center hidden'>
                <div className='flex gap-4 text-gray-600'>
                    {!mode?(<LightMode className="icons-style cursor-pointer" onClick={()=>dispatch(setMode())}/>):
                    (<DarkMode className="icons-style cursor-pointer" onClick={()=>dispatch(setMode())}/>)}
                    <Message className="icons-style cursor-pointer" />
                    <Notifications className="icons-style cursor-pointer"/>
                    <Help className="icons-style cursor-pointer"/>
                </div>
                <div className='select/input p-1 bg-gray-200 dark:bg-[#3D3B3B] rounded-md'>
                    <select className='bg-gray-200 dark:bg-[#3D3B3B] text-xs text-gray-500 cursor-pointer ' value={selectState} onChange={handleChange}>
                        <option value={selectState}>{selectState}</option>
                        <option value="Logout">Logout</option>
                    </select>
                </div>
            </div>
            ):
            (<Menu onClick={handleMenuToggle} className="cursor-pointer text-gray-600"/>)}
        </div>
    </div>
    {/* for small screen show slide menu appear from right */}
    {smallScreen?(
         <div style={{transform:`translateX(${value}%)`}} className="backdrop-blur-2xl py-4 w-1/2 h-full fixed top-[60px] right-0 bg-white dark:bg-gray-900 transition-all ease-in-out z-30 ">
            <div className='flex flex-col items-center gap-4'>
                <div className='flex flex-row px-4 py-1 rounded-md bg-gray-200 dark:bg-[#3D3B3B] w-[7rem] '>
                    <input className=' w-full text-sm bg-gray-200 dark:bg-[#3D3B3B]' type="text" placeholder='Search...' />
                    <Search className="text-gray-400 search-style bg-gray-200 dark:bg-[#3D3B3B]"/>
                </div>
                <div className='flex flex-col gap-4 text-gray-600'>
                    {!mode?(<LightMode className="icons-style cursor-pointer" onClick={()=>dispatch(setMode())}/>):
                    (<DarkMode className="icons-style cursor-pointer" onClick={()=>dispatch(setMode())}/>)}
                    <Message className="icons-style cursor-pointer" />
                    <Notifications className="icons-style cursor-pointer"/>
                    <Help className="icons-style cursor-pointer"/>
                </div>
                <div className='select/input p-1 bg-gray-200 dark:bg-[#3D3B3B] rounded-md'>
                    <select className='cursor-pointer bg-gray-200 text-xs text-gray-500 dark:bg-[#3D3B3B]' name='selectUser' value={firstName} onChange={handleChange}>
                        <option value={firstName}>{firstName}</option>
                        <option value="Logout">Logout</option>
                    </select>
                </div>
            </div>
         </div>
    ):null}
    </>
  )
}

export default Navbar